import type { BoxProps } from '@mui/material';
import { Box, IconButton, styled, Typography } from '@mui/material';
import type { FC, MouseEventHandler } from 'react';
import React from 'react';

interface CustomActivityLabelProps extends BoxProps {
  backgroundColor?: string;
  opacity?: number;
  textColor?: string;
  statusText?: string;
  icon?: React.ReactNode;
  isSmallScreen?: boolean;
  onClick?: MouseEventHandler<HTMLElement> | undefined;
}

const CustomActivityBoxStyle = styled(Box)<CustomActivityLabelProps>(
  ({ backgroundColor, opacity = 1, onClick }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
    backgroundColor: backgroundColor || 'transparent',
    padding: '4px 10px',
    alignItems: 'center',
    borderRadius: 24,
    '&:hover': {
      opacity: onClick ? opacity : 1,
    },
    cursor: onClick ? 'pointer' : 'default',
  }),
);

const CustomActivityLabel: FC<CustomActivityLabelProps> = ({
  backgroundColor,
  opacity,
  textColor = 'inherit',
  statusText,
  icon,
  isSmallScreen = false,
  onClick,
  ...boxProps
}) => (
  <CustomActivityBoxStyle
    backgroundColor={backgroundColor}
    opacity={opacity}
    onClick={onClick}
    {...boxProps}
  >
    {!isSmallScreen ? (
      <Typography
        noWrap
        color={textColor}
        variant="subtitle1"
        sx={{ lineHeight: 1 }}
      >
        {statusText}
      </Typography>
    ) : null}
    {icon ? (
      <IconButton
        sx={{
          padding: 0,
          ml: 0.2,
          '&:hover': { backgroundColor: 'transparent' },
        }}
        disableRipple
        size="small"
      >
        {icon}
      </IconButton>
    ) : null}
  </CustomActivityBoxStyle>
);

export default CustomActivityLabel;
